import React, { SVGProps } from 'react';

const SvgYoutubeMinimalBefore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 40 40" {...props}>
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z"
      fill="#F3F4F6"
    />
    <path
      d="M11.4704 24.2454C10.8432 21.4462 10.8432 18.5537 11.4704 15.7545C11.5528 15.4703 11.7121 15.2112 11.9325 15.0028C12.1528 14.7943 12.4268 14.6438 12.7274 14.5658C17.543 13.8114 22.4571 13.8114 27.2726 14.5658C27.5732 14.6438 27.8472 14.7943 28.0676 15.0028C28.288 15.2112 28.4472 15.4703 28.5296 15.7545C29.1568 18.5537 29.1568 21.4462 28.5296 24.2454C28.4472 24.5296 28.288 24.7887 28.0676 24.9971C27.8472 25.2056 27.5732 25.3561 27.2726 25.4341C22.4571 26.1887 17.543 26.1887 12.7274 25.4341C12.4268 25.3561 12.1528 25.2056 11.9325 24.9971C11.7121 24.7887 11.5528 24.5296 11.4704 24.2454Z"
      fill="#99A1AF"
      stroke="#99A1AF"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 22L22 20L18 18V22Z"
      fill="#F3F4F6"
      stroke="#F3F4F6"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
SvgYoutubeMinimalBefore.defaultProps = {
  width: '40',
  height: '40',
  color: 'currentColor',
};
export default SvgYoutubeMinimalBefore;
